import styled from 'styled-components';

// Main app layout
export const AdminApp = styled.div`
  display: flex;
  min-height: 100vh;
  min-height: 100dvh;
  width: 100%;
`;

export const MainContent = styled.div`
  flex: 1;
  margin-left: 250px;
  transition: margin-left 0.3s ease;
  display: flex;
  flex-direction: column;
  min-width: 0;

  &.sidebar-collapsed {
    margin-left: 70px;
  }

  @media (max-width: 768px) {
    margin-left: 0;
    width: 100%;
    
    &.sidebar-collapsed {
      margin-left: 0;
    }
  }
`;

export const PageContent = styled.div`
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  overflow-x: hidden;
  min-width: 0;

  @media (max-width: 768px) {
    padding: 14px 12px calc(88px + env(safe-area-inset-bottom));
  }

  @media (max-width: 420px) {
    padding-inline: 10px;
  }
`;

// Utility classes as styled components
export const Button = styled.button`
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

export const PrimaryButton = styled(Button)`
  background-color: #3b82f6;
  color: white;

  &:hover {
    background-color: #2563eb;
  }
`;

export const SecondaryButton = styled(Button)`
  background-color: #6b7280;
  color: white;

  &:hover {
    background-color: #4b5563;
  }
`;

export const SuccessButton = styled(Button)`
  background-color: #30D5C8;
  color: white;

  &:hover {
    background-color: #26a79d;
  }
`;

export const DangerButton = styled(Button)`
  background-color: #ef4444;
  color: white;

  &:hover {
    background-color: #dc2626;
  }
`;

export const Card = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  padding: 20px;
  margin-bottom: 20px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s ease;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  background-color: white;
  cursor: pointer;
`;

export const Badge = styled.span`
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const SuccessBadge = styled(Badge)`
  background-color: #dcfce7;
  color: #166534;
`;

export const WarningBadge = styled(Badge)`
  background-color: #fef3c7;
  color: #92400e;
`;

export const DangerBadge = styled(Badge)`
  background-color: #fee2e2;
  color: #991b1b;
`;

export const InfoBadge = styled(Badge)`
  background-color: #dbeafe;
  color: #1e40af;
`;

export const SecondaryBadge = styled(Badge)`
  background-color: #f3f4f6;
  color: #374151;
`;
